import { LNotification } from "@lib/abpUtility"
import { notifySuccess } from "@lib/helper"
import http from "@services/httpService"
import {
  IFeeReminderLadder,
  IFeeReminderLadderCreateOrUpdate,
} from "@models/feeNotification/feeReminderLadderModel"

// Req6: dịch vụ cấu hình thang nhắc phí theo dự án.
class FeeReminderLadderService {
  public async getListByProject(projectId: number): Promise<IFeeReminderLadder[]> {
    const res = await http.get(
      "api/services/app/FeeReminderLadder/GetListByProject",
      { params: { projectId } }
    )
    return res.data.result
  }

  public async get(id: number): Promise<IFeeReminderLadder> {
    const res = await http.get("api/services/app/FeeReminderLadder/Get", {
      params: { id },
    })
    return res.data.result
  }

  public async createOrUpdate(
    body: IFeeReminderLadderCreateOrUpdate
  ): Promise<IFeeReminderLadder> {
    const res = await http.post(
      "api/services/app/FeeReminderLadder/CreateOrUpdate",
      body
    )
    notifySuccess(LNotification("SUCCESS"), LNotification("SAVING_SUCCESSFULLY"))
    return res.data.result
  }

  public async delete(id: number): Promise<void> {
    await http.delete("api/services/app/FeeReminderLadder/Delete", {
      params: { id },
    })
    notifySuccess(LNotification("SUCCESS"), LNotification("DELETE_SUCCESSFULLY"))
  }

  // "Tạo đợt theo cấu hình": chạy ngay lịch của dự án thay vì chờ tới mốc. BE đưa vào background job và
  // chỉ TẠO đợt ở trạng thái Tạo mới — người dùng review rồi mới bấm Gửi.
  public async createBatchesByConfiguration(id: number): Promise<void> {
    await http.post("api/services/app/FeeReminderLadder/CreateBatchesByConfiguration", { id })
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("REMINDER_LADDER_RUN_NOW_ENQUEUED")
    )
  }
}

export default new FeeReminderLadderService()
